import React, { FC } from 'react'
import { Stack, StackProps } from '@mui/material'

export type StyledStackProps = StackProps & {
  /**
   * If `true`, mb=4.
   * @default: false, mb=0
   */
  mb4?: boolean
  /**
   * If `true`, spacing=4.
   * @default: false, spacing=3
   */
  sp4?: boolean
  /**
   * If `true`, direction='row'.
   * @default: false, direction='column'
   */
  row?: boolean
  /**
   * If `true`, alignItems='flex-start'.
   * @default: false, alignItems='center'
   */
  flexStart?: boolean
  /**
   * If `true`, justifyContent='space-between'.
   * @default: false, justifyContent= spaceBetween ? 'space-between' : flexEnd ? 'flex-end' : ''
   */
  spaceBetween?: boolean
  /**
   * If `true`, justifyContent='flex-end'.
   * @default: false, justifyContent= spaceBetween ? 'space-between' : flexEnd ? 'flex-end' : ''
   */
  flexEnd?: boolean
}

const StyledStack: FC<StyledStackProps> = props => {
  const {
    row = false,
    mb4 = false,
    sp4 = false,
    flexStart = false,
    flexEnd = false,
    spaceBetween = false,
    spacing = 3,
    sx = {},
    children,
    ...restProps
  } = props
  return (
    <Stack
      direction={row ? 'row' : 'column'}
      spacing={sp4 ? 4 : spacing}
      sx={{
        display: 'flex',
        alignItems: flexStart ? 'flex-start' : 'center',
        justifyContent: spaceBetween ? 'space-between' : flexEnd ? 'flex-end' : '',
        mb: mb4 ? 4 : 0,
        ...sx
      }}
      {...restProps}
    >
      {children}
    </Stack>
  )
}

export default StyledStack
